(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('#slideshow-{{ section.id }} .image-overlay').forEach(overlay => {
      overlay.classList.remove('loading')
    })
  })

  } catch(e) { console.error(e); }
})();
})();
